import axios from 'axios'
import { API_ADDRESS } from 'config'
import { BuildingConfig, BuildingImage } from 'config/constants/types'
import { BuildingsListing, BuildingsListingCheck } from 'state/types'

export const getBuildingListings = async (buildingId: string): Promise<BuildingsListing[]> => {
  const url = `${API_ADDRESS}/admin/buildings/list-listings?buildingId=${buildingId}`
  const { data } = await axios.get(url)

  return data
}

export const getBuildingListingsCsv = async (selectedListingIds: string[], buildingId: string): Promise<any[]> => {
  const listingObjectIds = selectedListingIds.toString()
  const url = `${API_ADDRESS}/admin/buildings/csv-listings?listingObjectIds=${listingObjectIds}&buildingId=${buildingId}`
  const { data } = await axios.get(url)

  return data
}

export const getBuilding = async (buildingId: string): Promise<BuildingConfig> => {
  const url = `${API_ADDRESS}/admin/buildings/get-building?buildingId=${buildingId}`
  const { data } = await axios.get(url)

  return data
}

export const updateBuildingUpdatedDate = async (buildingId: string): Promise<any> => {
  const url = `${API_ADDRESS}/building/update-updated-date?buildingId=${buildingId}`
  const { data } = await axios.post(url)

  return data
}

export const setStatus = async (
  buildingId: string,
  listingObjectIds: string[],
  status: string,
  userShortName: string,
): Promise<BuildingsListingCheck[]> => {
  const url = `${API_ADDRESS}/admin/buildings/check?buildingId=${buildingId}&type=status`
  const { data } = await axios.post(url, {
    listingObjIds: listingObjectIds,
    data: status,
    userShortName,
  })

  return data
}

export const addBuildingImages = async (buildingId: string, imageUrls: string): Promise<BuildingImage[]> => {
  const images = imageUrls.split('|')
  const url = `${API_ADDRESS}/admin/buildings/add-images?buildingId=${buildingId}`
  const { data } = await axios.post(url, {
    images,
  })

  return data
}

export const deleteBuildingImage = async (buildingId: string, imageId: number): Promise<BuildingImage[]> => {
  const url = `${API_ADDRESS}/admin/buildings/delete-image?buildingId=${buildingId}`
  const { data } = await axios.post(url, {
    imageId,
  })

  return data
}

export const addImageTag = async (buildingId: string, imageId: number, tag: string): Promise<BuildingImage[]> => {
  const url = `${API_ADDRESS}/admin/buildings/add-image-tag?buildingId=${buildingId}`
  const { data } = await axios.post(url, {
    imageId,
    tag,
  })

  return data
}

export const deleteImageTag = async (buildingId: string, imageId: number, tag: string): Promise<BuildingImage[]> => {
  const url = `${API_ADDRESS}/admin/buildings/delete-image-tag?buildingId=${buildingId}`
  const { data } = await axios.post(url, {
    imageId,
    tag,
  })

  return data
}

interface CreateBuildingListingsResponse {
  status: string
  message: string
  errors?: string[]
}

export const createBuildingListings = async (buildingId, upload): Promise<CreateBuildingListingsResponse> => {
  const url = `${API_ADDRESS}/admin/buildings/upload-listings?buildingId=${buildingId}`
  const { data } = await axios.post(url, upload)

  return data
}
